let isReady = false
let queuedRequests: Array<[string, boolean]> = []

const trigger = (tutorialId: string, onlyOnce: boolean): void => {
  window.Userlane(onlyOnce ? 'startOnce' : 'start', tutorialId)
}

const queue = (tutorialId: string, onlyOnce: boolean): void => {
  queuedRequests.push([tutorialId, onlyOnce])
}

const onReady = (): void => {
  isReady = true

  queuedRequests.forEach(([tutorialId, onlyOnce]) => {
    trigger(tutorialId, onlyOnce)
  })

  queuedRequests = []
}

const startListeringForUserlaneCompletion = (): void => {
  window.addEventListener('userlane:bootstrapped', onReady)
}

/**
 * Listen for the Userlane script ready event.
 */
export const mount = startListeringForUserlaneCompletion

const startInternal = (tutorialId: string, onlyOnce: boolean): void => {
  if (isReady) {
    trigger(tutorialId, onlyOnce)
  } else {
    queue(tutorialId, onlyOnce)
  }
}

/**
 * Trigger a Userlane tutorial. If the Userlane script is not ready, the request will be queued.
 * @param tutorialId
 */
export const start = (tutorialId: string): void => {
  startInternal(tutorialId, false)
}

/**
 * Trigger a Userlane tutorial. If the Userlane script is not ready, the request will be queued.
 * Triggers once per user.
 * @param tutorialId
 */
export const startOnce = (tutorialId: string): void => {
  startInternal(tutorialId, true)
}

export const teardown = (): void => {
  isReady = false
  window.removeEventListener('userlane:bootstrapped', onReady)
  queuedRequests = []
}
